import { defineMessages } from 'react-intl';

export default defineMessages({
  account: {
    id: 'sentinel.containers.details.account',
    defaultMessage: 'Account',
  },
  actionCreated: {
    id: 'sentinel.containers.details.actionCreated',
    defaultMessage: 'Action Created:',
  },
  descriptions: {
    id: 'sentinel.containers.details.descriptions',
    defaultMessage: 'Descriptions',
  },
  marginCalls: {
    id: 'sentinel.containers.details.marginCalls',
    defaultMessage: 'Margin Calls',
  },
  noResults: {
    id: 'sentinel.containers.details.noResults',
    defaultMessage: 'No transfer found with id:',
  },
  submitActionSuccess: {
    id: 'sentinel.containers.details.submitActionSuccess',
    defaultMessage: 'The following actions were successfully resolved:',
  },
  rejectTransferSuccess: {
    id: 'sentinel.containers.details.rejectTransferSuccess',
    defaultMessage: 'This transfer has successfully been rejected.',
  },
  reopenTransferSuccess: {
    id: 'sentinel.containers.details.reopenTransferSuccess',
    defaultMessage: 'This transfer has been reopened and has been resubmitted for approval.',
  },
  returnTransferSuccess: {
    id: 'sentinel.containers.details.returnTransferSuccess',
    defaultMessage: 'This transfer has successfully been returned.',
  },
  suspendTransferSuccess: {
    id: 'sentinel.containers.details.suspendTransferSuccess',
    defaultMessage: 'This transfer has been suspended.',
  },
  cancelTransferSuccess: {
    id: 'sentinel.containers.details.cancelTransferSuccess',
    defaultMessage: 'This transfer has been canceled.',
  },
  updateAmountSuccess: {
    id: 'sentinel.containers.details.updateAmountSuccess',
    defaultMessage: 'Amount was successfully changed from',
  },
  updateAccountSuccess: {
    id: 'sentinel.containers.details.updateAccountSuccess',
    defaultMessage: 'Account was successfully changed from',
  },
  updateWireDescriptionsSuccess: {
    id: 'sentinel.containers.details.updateWireDescriptionsSuccess',
    defaultMessage: 'This transfer has been successfully updated.',
  },
  errorMessagePrefix: {
    id: 'sentinel.containers.details.errorMessagePrefix',
    defaultMessage: 'One or more request failed:',
  },
  backToSearch: {
    id: 'sentinel.containers.details.backToSearch',
    defaultMessage: 'Back To Search',
  },
  recentDeposits: {
    id: 'sentinel.containers.details.recentDeposits',
    defaultMessage: 'Recent Deposits',
  },
  rejectTransfer: {
    id: 'sentinel.containers.details.rejectTransfer',
    defaultMessage: 'Reject',
  },
  reopenTransfer: {
    id: 'sentinel.containers.details.reopenTransfer',
    defaultMessage: 'Reopen',
  },
  travelRuleDetails: {
    id: 'sentinel.containers.details.travelRuleDetails',
    defaultMessage: 'Travel Rule Details',
  },
  transferFees: {
    id: 'sentinel.containers.details.transferFees',
    defaultMessage: 'Transfer Fees',
  },
});



// WEBPACK FOOTER //
// ./src/containers/Details/messages.js